export const viewTitle = "Список актов приёма-передачи дел";
export const viewUniqKey = "acts";
